export const useMiros = sharedComposable(() => {
  const {
    public: {
      scripts: {
        miros: { integrationId },
      },
    },
  } = useRuntimeConfig()

  let readyPromise = Promise.resolve()

  return useScript(
    {
      src: 'https://content.miros.services/frontend/public/main/container/assets/container.bundle.js',
      type: 'module',
      async: true,
      'data-miros-integration-id': integrationId,
    },
    {
      beforeInit() {
        if (import.meta.client) {
          readyPromise = new Promise((resolve) => {
            const cleanup = useEventListener(
              window,
              'Miros Load',
              () => {
                resolve()
                cleanup()
              },
              { passive: true }
            )
          })
        }
      },
      use() {
        const dispatch = (name: string, detail: unknown) => {
          if (import.meta.client) {
            readyPromise.then(() => window.dispatchEvent(new CustomEvent(name, { detail })))
          }
        }

        interface MirosItem {
          alias: number
          price: number
          quantity: number
          currency: string
        }

        return {
          externalAddItemToCart: (item: MirosItem) => dispatch('ExternalAddItemToCart', item),
          checkout: (items: MirosItem[]) => dispatch('Checkout', items),
        }
      },
    }
  )
})
